const PaymentMaster = {

    "role": "Role",
    "recurring_payment": "Recurring Payment",
    "status": "Status",
    "search": "Search",

    "payment": "Payment Master",

    "error_role": "Select Role",
    "error_amount": "Enter Recurring Payment",
    "error_status": "Select Status",

    "table_role": "ROLE",
    "table_amount": "RECURRING PAYMENT",
    "table_status": "STATUS",

}

export default PaymentMaster;
